
// jobCandidateService.ts
import axiosInstance from "./axiosConfig";
import { getUser } from "./authService";

// Job list interface
export interface JobLS {
  jobTitle: string;
  jobId: string;
  status: string;
}

// Job details interface
export interface JobDetail {
  jobTitle: string;
  jobId: string;
  AdditionalInformation: string;
  location: string;
  status: string;
  deadline: string;
  screeningQuestions: string[];
  stats: {
    total: number;
    shortlisted: number;
    finalized: number;
    rejected: number;
  };
}

// Candidate interface
export interface Candidate {
  id: string;
  name: string;
  email: string;
  phone: string;
  status: string;
  submitted: string;
  answers?: string[] | string;
  cvFilePath?: string;
}

// Get all jobs list for the current user's company
export const getJobsList = async (): Promise<JobLS[]> => {
  try {
    const response = await axiosInstance.get<JobLS[]>("/jobs/list");
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch jobs list");
  }
};

// Get a specific job by ID
export const getJobById = async (jobId: string): Promise<JobDetail> => {
  try {
    const response = await axiosInstance.get<JobDetail>(`/jobs/${jobId}`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch job details");
  }
};

export const getCandidatesByJobId = async (jobId: string): Promise<Candidate[]> => {
    try {
      const response = await axiosInstance.get<any>(`/jobs/${jobId}/candidates`);
      console.log("API Response:", response);
      
      // Handle various response structures
      if (Array.isArray(response.data)) {
        return response.data;
      } else if (response.data?.items && Array.isArray(response.data.items)) {
        return response.data.items;
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      
      // If the response doesn't match expected formats, return empty array
      console.warn("Unexpected response structure:", response.data);
      return [];
    } catch (error) {
      console.error("Error fetching candidates:", error);
      return []; // Return empty array instead of throwing to prevent component crashes
    }
  };
// Update candidate status
export const updateCandidateStatus = async (candidateId: string, status: string): Promise<Candidate> => {
  try {
    const response = await axiosInstance.patch<Candidate>(`/candidates/${candidateId}`, { status });
    return response.data;
  } catch (error) {
    throw new Error("Failed to update candidate status");
  }
};

// Download candidate CV
export const getCandidateCV = async (candidateId: string): Promise<Blob> => {
  try {
    const response = await axiosInstance.get(`jobs/candidates/${candidateId}/cv`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch candidate CV");
  }
};